import { render, staticRenderFns } from "./RequestButtonDataTable.vue?vue&type=template&id=3fc970aa&scoped=true"
import script from "@/components/request/RequestButtonDataTable/RequestButtonDataTable.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestButtonDataTable/RequestButtonDataTable.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestButtonDataTable/request-button-data-table.scss?vue&type=style&index=0&id=3fc970aa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc970aa",
  null
  
)

export default component.exports